module.exports = {"450126100":"宾州镇","450126101":"黎塘镇","450126102":"甘棠镇","450126103":"思陇镇","450126104":"新桥镇","450126105":"新圩镇","450126106":"邹圩镇","450126107":"大桥镇","450126108":"武陵镇","450126109":"中华镇","450126110":"古辣镇","450126111":"露圩镇","450126112":"王灵镇","450126113":"和吉镇","450126114":"洋桥镇","450126115":"陈平镇","450126451":"廖平农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450126.json
// module id = 2205
// module chunks = 0